import { API_BASE_URL } from '../settings';
import { Assessment } from '../models/index';
import axios from 'axios';

export const getAssessments = () => {
  return axios.get(API_BASE_URL + 'assessments')
    .then(res => res.data)
    .then(res => res.data);
}
export const getAssessmentsByCompanyId = companyId => {
  return axios.get(API_BASE_URL + 'assessments?companyId=' + companyId)
    .then(res => res.data)
    .then(res => res.data);
}

export const getAssessment = assessmentId => {
  return axios.get(API_BASE_URL + 'assessments/' + assessmentId)
    .then(res => res.data)
    .then(res => res.data);
}

export const createAssessment = (assessment) => {
  return axios.post(API_BASE_URL + 'assessments', Assessment(assessment))
    .then(res => res.data)
    .then(res => res.data);
};

export const updateAssessment = (assessmentId, assessment) => {
  return axios.put(API_BASE_URL + 'assessments/' + assessmentId, Assessment(assessment))
    .then(res => res.data)
    .then(res => res.data);
};

export const updateAnsweredQuestions = (assessmentId, answeredQuestions) => {
  return axios.put(API_BASE_URL + 'assessments/' + assessmentId + '/update-answers/', { answeredQuestions: answeredQuestions })
    .then(res => res.data)
    .then(res => res.data);
};

export const getAssessmentResults = (assessmentId, dateTime) => {
  return axios.get(API_BASE_URL + 'assessments/' + assessmentId + '/results?date=' + dateTime)
    .then(res => res.data)
    .then(res => res.data);
}

export const getAssessmentReportFile = reportFileId => {
  return API_BASE_URL + 'report-files/' + reportFileId;
} 


// WEBPACK FOOTER //
// ./src/services/assessment.services.js